class VariantChange  extends HTMLElement {
	constructor() {
		super();
		const _this = this;
		this.radioButons = this.querySelectorAll('input[type="radio"]')
		if(this.radioButons){
			this.radioButons.forEach(function (input){
				input.addEventListener('change', _this.changeVariant.bind(_this));
			})
		}

	}
	changeVariant(){
		this.getVariantId();
		this.getCurrentVariant();
		this.updateUrl();
		this.updateSizeSelectorHeader();
		this.updateContent();

	}
	getVariantId() {
		this.variantId = this.querySelector('input[type="radio"]:checked').value
	}

	updateSizeSelectorHeader(){
		this.querySelector('.js-size-selector-header-size').textContent = this.currentVariant.title;
	}
	getCurrentVariant(){
		const variantJson = JSON.parse(this.querySelector('[type="application/json"]').textContent)
		this.currentVariant = variantJson.find((variant) => variant.id == this.variantId );
	}
	updateUrl(){
		if (!this.currentVariant) return;
		window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}
	updateContent(){
		if(this.closest('.js-product-info').querySelector('product-form form input[name="id"]')){
			this.closest('.js-product-info').querySelector('product-form form input[name="id"]').value =this.currentVariant.id;
		}
		if(document.querySelector('.js-product-info product-form')) {
			if (document.querySelector('.js-product-info product-form').querySelectorAll('button[name="add"]')) {
				document.querySelector('.js-product-info product-form').querySelectorAll('button[name="add"]').forEach(function (button) {
					button.classList.add('loading');
				})
			}
		}

		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
			.then((response) => {
				return response.text();
			})
			.then((response_html) => {
				const html = new DOMParser().parseFromString(response_html, 'text/html');
				const fetchPrice = html.querySelector('[data-product-price]');
				const fetchFeatures = html.querySelector('[data-product-features]');
				const fetchButton = html.querySelectorAll('[data-product-button]');
				const price = document.querySelector('[data-product-price]');
				const features = document.querySelector('[data-product-features]');
				const button = document.querySelectorAll('[data-product-button]');
				const dynamicButton = document.querySelector('.dynamic-checkout-button');
				const productInfoSubmit = document.querySelector('.js-product-info product-form .product-info-submit');
				const productActionButton = document.querySelector('.js-product-info product-form .product-action-buttons');
				if(fetchPrice && price){
					price.innerHTML = fetchPrice.innerHTML
				}
				if(fetchFeatures && features){
					features.innerHTML = fetchFeatures.innerHTML
				}
				if(fetchButton && button){
					button.forEach(function (buttonItem, index){
						buttonItem.innerHTML = fetchButton[index].innerHTML;
						if(fetchButton[index].hasAttribute('disabled')){
							buttonItem.setAttribute('disabled','disabled');
							if(productInfoSubmit){
								productInfoSubmit.classList.add('hide')
							}
							if(productActionButton){
								productActionButton.classList.add('show')
							}
						}else{
							buttonItem.removeAttribute('disabled');
							if(productInfoSubmit){
								productInfoSubmit.classList.remove('hide')
							}
							if(productActionButton){
								productActionButton.classList.remove('show')
							}
						}
					})
				}
				if(dynamicButton){
					dynamicButton.removeAttribute('style')
				}
				if(document.querySelector('.js-product-info product-form')){
					if(document.querySelector('.js-product-info product-form').querySelectorAll('button')){
						document.querySelector('.js-product-info product-form').querySelectorAll('button').forEach(function (button){
							button.classList.remove('loading');
						})
					}
				}

				addCountryFlag();

			}) .catch((e) => {
			console.error(e);
		});

	}

}
customElements.define('variant-buttons', VariantChange )

